export const GoogleMapApiConfig = 'AIzaSyByKA2PtKeR2E4eQ65QchR8Hyi5Cqh45X0';